/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "components/CustomButtons/Button";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import ErrorIcon from "@material-ui/icons/Error";
import Card from "components/Card/Card";
import viking from "../../assets/img/vikingstransparent_logo.png";

// Create custom styles using Material-UI's makeStyles
const useStyles = makeStyles(styles);

const AlreadyRegister = props => {
  // State to track the forgetPassword value from props
  const [preForgetPassword, setPrePassword] = React.useState(
    props.formData.forgetPassword
  );

  // Initialize styles
  const classes = useStyles();

  // Navigate back to the login page
  const handleBackToLogin = () => {
    props.history.push("/admin/login");
  };

  // Navigate to the reset password page
  const handleForgetPassword = () => {
    props.history.push("/resetPassword");
  };

  // Effect to update the state if forgetPassword prop changes
  React.useState(() => {
    if (preForgetPassword !== props.formData.forgetPassword) {
      setPrePassword(props.formData.forgetPassword);
    }
  });

  return (
    <Card style={{ width: "55%" }}>
      {/* Logo Section */}
      <Grid container style={{ marginTop: "5%" }}>
        <Grid item xs style={{ textAlign: "center" }}>
          <img src={viking} width="30%" height="auto" alt="" />
        </Grid>
      </Grid>

      {/* Error Icon Section */}
      <Grid container style={{ margin: "1% 0% 0% 0%" }}>
        <Grid iten xs={2} />
        <Grid iten xs={8} style={{ textAlign: "center" }}>
          <ErrorIcon style={{ fontSize: "75px", color: "#FF0000" }} />
        </Grid>
        <Grid iten xs={2} />
      </Grid>

      {/* Message Section */}
      <Grid container>
        <Grid iten xs={2} />
        <Grid
          item
          xs={8}
          style={{
            margin: "3% 0% 0% 0%",
            fontSize: "16px",
            color: "#3a57a7",
            fontFamily: "sans-serif",
          }}
        >
          <div style={{ textAlign: "center" }}>
            {/* Display appropriate message based on forgetPassword state */}
            {!preForgetPassword ? (
              <div>
                You are already a registered user of VIKExpress. Kindly login to manage your payments.
              </div>
            ) : (
              <div>{preForgetPassword.message}</div>
            )}
          </div>
        </Grid>
        <Grid iten xs={2} />
      </Grid>

      {/* Buttons Section */}
      <Grid container style={{ marginTop: "2%", marginBottom: "10%" }}>
        <Grid item xs={3} />
        <Grid item xs={3} textAlign="center" style={{ display: "flex", justifyContent: "space-around" }}>
          {/* Login Button */}
          <Button
            variant="contained"
            onClick={() => handleBackToLogin()}
            size="large"
          >
            Login
          </Button>
        </Grid>
        {/* Forgot Password Button (conditionally rendered) */}
        {!preForgetPassword && (
          <Grid item xs={3} textAlign="center">
            <Button
              variant="contained"
              onClick={() => handleForgetPassword()}
              className={classes.clearButton1}
              size="large"
            >
              Forgot Password
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid item xs={3} />
    </Card>
  );
};

// Define prop types for the component
AlreadyRegister.propTypes = {
  history: PropTypes.object, // React Router history object for navigation
  formData: PropTypes.object, // Form data passed as props
  confirmForgetPassword: PropTypes.func, // Function to confirm forget password (if applicable)
};

// Export the component as default
export default AlreadyRegister;
